import { CITATION_SAMPLE } from '../classnames/scientific-citations';
import { HIDDEN } from '../classnames/design-system';

export default class CitationComponent {
  constructor({ citation }) {
    this.citation = citation;
  }

  citationSample = document.querySelector(`.${CITATION_SAMPLE}`);

  render = () => {
    const {
      index,
      slug,
      url,
      text
    } = this.citation;
    const newCitation = this.citationSample.cloneNode(true);
    const newCitationLink = newCitation.querySelector('a');
    newCitation.id = slug;
    newCitationLink.href = url;
    newCitationLink.innerHTML = `${index}. ${text}`;
    newCitation.classList.remove(HIDDEN);
    return newCitation;
  };
}
